define('lpg',['require','exports','module'],function (require, exports, module) {
  "use strict";

  /** General style scripts, replace for previous bootstrap.js **/
  $(document)
      //DROPDOWNS - basic
      .on("click", ".ed-dropdown .ed-dropdown-toggle", function (e) {
        e.stopPropagation();
        e.preventDefault();

        var $dropdown = $(e.currentTarget).parent();
        if ($dropdown.hasClass("ed-btn-dropdown-complex")) $dropdown = $dropdown.parent();
        $dropdown.toggleClass("open");
      })

      //DROPDOWNS - close on menu item click
      .on("click", ".ed-dropdown-menu li a", function (e) {
        $(e.currentTarget).closest(".ed-dropdown").toggleClass("open", false);
      })

      //MODALS - using data attrs
      .on("click", ".ed-open-modal", function (e) {
        var modalId = $(e.currentTarget).attr("data-target");
        if (modalId) {
          //$(modalId).removeClass("hidden");
          $(modalId).trigger("show.bs.modal");
        }
      })

      //MODALS - close button
      .on("click", ".ed-overlay-container .js-close", function (e) {
        var modalContainer = $(e.currentTarget).closest(".ed-overlay");
        modalContainer.trigger("hide.bs.modal");
      });

  //DROPDOWNS - close on click outside of the menu
  $('html').click(function (e) {
    if (!$(e.target).closest(".ed-dropdown").length) {
      $(".ed-dropdown").removeClass("open");
    }
  });
});

